import { Box, Typography, Button } from '@mui/material';
import Avatar from 'src/components/Avatar';
import { FC } from 'react';

interface DashHeaderProps {
  title: string;
  showButton?: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
  showAvatar?: boolean;
}

const DashHeader: FC<DashHeaderProps> = ({
  title,
  showButton = false,
  buttonText = '',
  onButtonClick,
  showAvatar = false,
}) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={3}
    >
      <Typography
        fontFamily="Lufga"
        fontWeight="500"
        fontSize="24px"
        color="var(--primary-navy)"
        mt={1}
      >
        {title}
      </Typography>
      {showButton && (
        <Button variant="contained" color="primary" onClick={onButtonClick}>
          {buttonText}
        </Button>
      )}
      {showAvatar && <Avatar />}
    </Box>
  );
};

export default DashHeader;
